/*
 * validator のラップ関数（形式チェック関連）
 * https://github.com/validatorjs/validator.js#validators
 */
import validatorIsEmail from 'validator/lib/isEmail';
import validatorIsURL from 'validator/lib/isURL';
/**
 * メールアドレスとして正しい形式か
 * @param value
 * @returns
 */
export const isEmail = (value) => validatorIsEmail(value);
/**
 * URLとして正しい形式か
 * @param value
 * @returns
 */
export const isURL = (value) => validatorIsURL(value);
